import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { Droppable as DndDroppable } from "react-beautiful-dnd";

export function Droppable({ children, ...props }: any) {
  const [enabled, setEnabled] = useState(false);

  // for react-beautiful-dnd's strict mode issue
  useEffect(() => {
    const animation = requestAnimationFrame(() => setEnabled(true));

    return () => {
      cancelAnimationFrame(animation);
      setEnabled(false);
    };
  }, []);

  if (!enabled) {
    return null;
  }

  return <DndDroppable {...props}>{children}</DndDroppable>;
}

Droppable.propTypes = {
  children: PropTypes.any,
};
